jQuery(function ($) {
    if ( $('.member-image-list').length && ! $('.member-image-no-image').length ) {
        $('.member-image-list').on('init', function(){
            $('.member-image-list').show();
        });
        function set_slick(infinite) {
            $('.member-image-list').slick({
                infinite: infinite,
                slidesToShow: 4,
                slidesToScroll: 4,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                        }
                    },
                ],
            });
        }
        set_slick(false);
    }
    if ( $('.member-image-no-image').length ) {
        $('.member-image-list').show();
    }
});